import { useMutation } from '@tanstack/react-query';

import { AllowedTimeFormSchemaValues } from 'src/features/allowedTimes/utils/formSchema';
import { AllowedTimes } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/memberships/membership/:membershipId/allowed-times/:allowedTimeId/';

interface DTO extends AllowedTimeFormSchemaValues {
    membershipId: string;
    allowedTimeId: string;
    parkingId: string;
}
const mutationFn = ({ membershipId, allowedTimeId, parkingId, ...data }: DTO): Promise<AllowedTimes> => {
    return axios.put(formatResourcePath(RESOURCE, { membershipId, allowedTimeId, parkingId }), data);
};

type MutationFnType = typeof mutationFn;

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_MEMBERSHIP_ALLOWED_TIME_RESOURCE, useMutationHook as useUpdateMembershipAllowedTime };
